import { render, staticRenderFns } from "./CatalogProblem.vue?vue&type=template&id=c0c06c3e&scoped=true&"
import script from "./CatalogProblem.vue?vue&type=script&lang=js&"
export * from "./CatalogProblem.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProblem.vue?vue&type=style&index=0&id=c0c06c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c06c3e",
  null
  
)

export default component.exports